(() => {
  const STORAGE_KEY = "cart_consents_terms_ok";

  function $(sel, root = document) { return root.querySelector(sel); }
  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  // ========= FAST GUARDS =========
  // Jeśli na stronie nie ma ani zgód, ani modalów, ani checkout triggerów,
  // to nie ma sensu odpalać reszty.
  function pageMightNeedThis() {
    // NOTE: checkout przyciski są dynamiczne (drawer), więc i tak
    // globalne listenery zostawiamy. Guardy ograniczamy głównie do bindConsents().
    return true;
  }

  // Cache "czy istnieją zgody" — aktualizowane w bindConsents()
  let _hasAnyConsents = null;
  function anyConsentsExist() {
    if (_hasAnyConsents !== null) return _hasAnyConsents;
    _hasAnyConsents = !!document.querySelector("[data-cart-consents]");
    return _hasAnyConsents;
  }

  function isVisible(el) {
    if (!el) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;
    return true;
  }

  function getConsentCheckbox(container) {
    return container?.querySelector('input[type="checkbox"][data-consent="terms"]') || null;
  }

  function findBestConsentContainer(btnOrForm) {
    // 1) jeśli kliknęliśmy w obrębie kontenera zgód
    const direct = btnOrForm?.closest?.("[data-cart-consents]");
    if (direct && isVisible(direct)) return direct;

    // 2) kontekst: drawer vs page
    const drawerCtx = btnOrForm?.closest?.("cart-drawer, .drawer, [data-cart-drawer], .drawer__inner");
    const pageCtx   = btnOrForm?.closest?.("main-cart, #MainCart, .cart");

    // priorytet: w tym samym kontekście i widoczne
    const scopedDrawer = drawerCtx ? drawerCtx.querySelector('[data-cart-consents][data-scope="drawer"]') : null;
    if (scopedDrawer && isVisible(scopedDrawer)) return scopedDrawer;

    const scopedPage = pageCtx ? pageCtx.querySelector('[data-cart-consents][data-scope="page"]') : null;
    if (scopedPage && isVisible(scopedPage)) return scopedPage;

    // 3) fallback: widoczne page, potem widoczne drawer
    const visPage = $all('[data-cart-consents][data-scope="page"]').find(isVisible);
    if (visPage) return visPage;

    const visDrawer = $all('[data-cart-consents][data-scope="drawer"]').find(isVisible);
    if (visDrawer) return visDrawer;

    // 4) ostatecznie: jakikolwiek (ale może być ukryty)
    return document.querySelector("[data-cart-consents]");
  }

  function showConsentError(container) {
    if (!container) return;
    const err = container.querySelector(".cart-consents__error");
    if (err) err.style.display = "block";

    const row = container.querySelector(".cart-consent");
    if (row) {
      row.classList.add("cart-consent--error");
      row.addEventListener("animationend", () => row.classList.remove("cart-consent--error"), { once: true });
    }
  }

  function enforceConsentOrBlock(triggerEl, eventToPrevent) {
    // Jeśli na stronie nie ma żadnych zgód, nie blokuj
    if (!anyConsentsExist()) return true;

    const container = findBestConsentContainer(triggerEl);

    // jeśli są zgody, ale nie umiemy znaleźć kontenera -> BLOKUJ (bezpieczniej)
    if (!container) {
      if (eventToPrevent) eventToPrevent.preventDefault();
      return false;
    }

    const cb = getConsentCheckbox(container);

    // jeśli kontener jest, ale checkboxa brak -> BLOKUJ
    if (!cb) {
      if (eventToPrevent) eventToPrevent.preventDefault();
      showConsentError(container);
      try { sessionStorage.setItem(STORAGE_KEY, "0"); } catch (_) {}
      return false;
    }

    if (cb.checked) return true;

    if (eventToPrevent) eventToPrevent.preventDefault();
    showConsentError(container);
    try { sessionStorage.setItem(STORAGE_KEY, "0"); } catch (_) {}
    return false;
  }

  async function loadPolicyInto(modal) {
    const box = modal?.querySelector("[data-cp-content]");
    if (!box) return;
    if (box.dataset.loaded === "1") return;

    const type = box.dataset.policy; // "terms" | "privacy"
    const url = type === "terms" ? "/policies/terms-of-service" : "/policies/privacy-policy";

    try {
      box.textContent = "Loading…";
      const res = await fetch(url, { credentials: "same-origin" });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const main = doc.querySelector(".shopify-policy__body") || doc.querySelector("main") || doc.body;

      box.innerHTML = main ? main.innerHTML : html;
      box.dataset.loaded = "1";
    } catch (e) {
      box.innerHTML = "<p>Could not load content. Please try again.</p>";
    }
  }

  async function openModal(modal) {
    if (!modal) return;
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    await loadPolicyInto(modal);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute("aria-hidden", "true");
    modal.style.display = "none";
    document.documentElement.style.overflow = "";
  }

  // ========= BINDING (OPTIMIZED) =========
  // 1) bindujemy kontenery zgód TYLKO w przekazanym root
  // 2) modale bindujemy globalnie tylko raz (delegacja)
  let _modalsBound = false;

  function bindModalsOnce() {
    if (_modalsBound) return;
    _modalsBound = true;

    // Kliknięcia na backdrop / close (delegacja)
    document.addEventListener("click", (ev) => {
      const closeBtn = ev.target.closest("[data-modal-close]");
      if (closeBtn) {
        const modal = ev.target.closest(".cp-modal") || closeBtn.closest(".cp-modal");
        if (modal) closeModal(modal);
        return;
      }

      const modal = ev.target.closest(".cp-modal");
      if (modal) {
        // klik poza dialogiem
        const dlg = modal.querySelector(".cp-modal__dialog");
        if (dlg && !dlg.contains(ev.target)) closeModal(modal);
      }
    });

    // Otwieranie modali (delegacja)
    document.addEventListener("click", (ev) => {
      const a = ev.target.closest("[data-modal-trigger]");
      if (!a) return;
      ev.preventDefault();
      const id = a.getAttribute("data-modal-trigger");
      openModal(document.getElementById(id));
    });
  }

  function bindConsents(root = document) {
    // SZYBKI EXIT: jeśli w tym root nie ma kontenerów zgód, nic nie rób
    // (na cart:updated dostaniesz często root = document, ale na większości stron to nadal szybkie)
    const found = root.querySelector?.("[data-cart-consents]");
    if (!found) {
      // aktualizuj cache "czy istnieją zgody" tylko gdy sprawdzamy cały dokument
      if (root === document) _hasAnyConsents = !!document.querySelector("[data-cart-consents]");
      return;
    }

    // skoro znaleźliśmy, to globalny cache = true
    if (root === document) _hasAnyConsents = true;

    // modale zawsze bind raz
    bindModalsOnce();

    $all("[data-cart-consents]", root).forEach((c) => {
      if (c.dataset.bound) return;
      c.dataset.bound = "1";

      // restore from sessionStorage
      try {
        if (sessionStorage.getItem(STORAGE_KEY) === "1") {
          const cb = getConsentCheckbox(c);
          if (cb) cb.checked = true;
        }
      } catch (_) {}

      // change listener per container (OK, mało elementów)
      c.addEventListener("change", (e) => {
        if (e.target.matches('input[type="checkbox"][data-consent="terms"]')) {
          const err = c.querySelector(".cart-consents__error");
          const row = c.querySelector(".cart-consent");
          if (err) err.style.display = "none";
          if (row) row.classList.remove("cart-consent--error");
          try { sessionStorage.setItem(STORAGE_KEY, e.target.checked ? "1" : "0"); } catch (_) {}
        }
      });
    });
  }

  if (!pageMightNeedThis()) return;

  // ========= BLOCK CHECKOUT =========
  // 1) CLICK – blokuj checkout
  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[name="checkout"], [type="submit"][name="checkout"], a[href*="/checkout"]');
    if (!btn) return;

    const ok = enforceConsentOrBlock(btn, e);
    if (!ok) return;
  }, true);

  // 2) SUBMIT – blokuj submit formularza koszyka, jeśli idzie checkout
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = (form.getAttribute("action") || "").toLowerCase();
    const isCartForm = action.includes("/cart");
    if (!isCartForm) return;

    const submitter = e.submitter;
    const looksLikeCheckout =
      submitter?.getAttribute?.("name") === "checkout" ||
      !!form.querySelector('button[name="checkout"], [type="submit"][name="checkout"]');

    if (!looksLikeCheckout) return;

    const ok = enforceConsentOrBlock(form, e);
    if (!ok) return;
  }, true);

  // 3) HARD BLOCK – nawet jeśli ktoś robi form.submit()/requestSubmit() bez eventów
  (function hardBlockProgrammatic() {
    const origSubmit = HTMLFormElement.prototype.submit;
    const origRequestSubmit = HTMLFormElement.prototype.requestSubmit;

    function isCartForm(form) {
      const action = (form.getAttribute("action") || "").toLowerCase();
      return action.includes("/cart");
    }

    HTMLFormElement.prototype.submit = function () {
      try {
        if (isCartForm(this)) {
          const ok = enforceConsentOrBlock(this, null);
          if (!ok) return;
        }
      } catch (_) {}
      return origSubmit.call(this);
    };

    if (origRequestSubmit) {
      HTMLFormElement.prototype.requestSubmit = function (submitter) {
        try {
          if (isCartForm(this)) {
            const looksLikeCheckout =
              submitter?.getAttribute?.("name") === "checkout" ||
              !!this.querySelector('button[name="checkout"], [type="submit"][name="checkout"]');

            if (looksLikeCheckout) {
              const ok = enforceConsentOrBlock(this, null);
              if (!ok) return;
            }
          }
        } catch (_) {}
        return origRequestSubmit.call(this, submitter);
      };
    }
  })();

  // ========= INIT / RE-BIND HOOKS =========
  // bind na start
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bindConsents(document), { once: true });
  } else {
    bindConsents(document);
  }

  // sekcje + koszyk
  document.addEventListener("shopify:section:load", (e) => bindConsents(e.target));
  document.addEventListener("cart:updated", () => bindConsents(document));
})();